// apps/website/src/components/NavEventBridge.tsx
// Bridges CustomEvent('dg:navigate') into SPA navigation via react-router.

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

type NavEventDetail = {
  path: string;
  replace?: boolean;
  delayMs?: number; // optional: small defer to let chat commit its last turn
};

export function NavEventBridge() {
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (e: Event) => {
      const ce = e as CustomEvent<NavEventDetail>;
      const detail = ce?.detail;
      const path = detail?.path;

      if (typeof path !== 'string' || !path.startsWith('/')) return;

      const go = () => {
        if (detail?.replace) {
          navigate(path, { replace: true });
        } else {
          navigate(path);
        }
      };

      // Optional delay to allow any pending chat tool_result to render.
      const delay = typeof detail?.delayMs === 'number' && detail.delayMs > 0 ? detail.delayMs : 0;
      if (delay > 0) {
        setTimeout(go, delay);
      } else {
        go();
      }
    };

    window.addEventListener('dg:navigate', handler as EventListener);
    return () => window.removeEventListener('dg:navigate', handler as EventListener);
  }, [navigate]);

  return null;
}

export default NavEventBridge;
